import { render, staticRenderFns } from "./print_fkqkd.vue?vue&type=template&id=15c88a4b&scoped=true&"
import script from "./print_fkqkd.vue?vue&type=script&lang=js&"
export * from "./print_fkqkd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c88a4b",
  null
  
)

export default component.exports